// Imports
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(true);
// Module
___CSS_LOADER_EXPORT___.push([module.id, ".chat-message-content[data-v-72486bc4]{max-width:100%}", "",{"version":3,"sources":["webpack://src/components/chat/ChatMessageContent.vue"],"names":[],"mappings":"AAAA,uCAAuC,cAAc","sourcesContent":[".chat-message-content[data-v-72486bc4]{max-width:100%}"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
